import { render, staticRenderFns } from "./PrinttextlabelPage.vue?vue&type=template&id=1621287a"
import script from "./PrinttextlabelPage.vue?vue&type=script&lang=js"
export * from "./PrinttextlabelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports